package io.jsonize.web.screens.editor

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.FormatIndentDecrease
import androidx.compose.material.icons.automirrored.filled.FormatIndentIncrease
import androidx.compose.material.icons.filled.AccountTree
import androidx.compose.material.icons.filled.Code
import androidx.compose.material.icons.filled.Compare
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Download
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.unit.dp
import io.jsonize.web.services.FileExport
import io.jsonize.web.components.TooltipIconButton

@Composable
fun EditorToolbar(
    text: String,
    isFormatting: Boolean,
    onFormat: () -> Unit,
    onMinify: () -> Unit,
    onCancel: () -> Unit,
    onCopy: () -> Unit,
    onSearch: () -> Unit,
    viewMode: EditorViewMode,
    onViewModeChange: (EditorViewMode) -> Unit,
    showViewToggle: Boolean
) {
    val clipboard = LocalClipboardManager.current
    val isMinified = isLikelyMinifiedJson(text)
    val formatIcon = if (isMinified) {
        Icons.AutoMirrored.Default.FormatIndentIncrease
    } else {
        Icons.AutoMirrored.Default.FormatIndentDecrease
    }
    val formatDescription = if (isMinified) "Format" else "Unformat"

    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
        /*if (showViewToggle) {
            ViewModeButton(
                selected = viewMode == EditorViewMode.Code,
                onClick = { onViewModeChange(EditorViewMode.Code) },
                icon = Icons.Default.Code,
                description = "Code view"
            )
            ViewModeButton(
                selected = viewMode == EditorViewMode.Tree,
                onClick = { onViewModeChange(EditorViewMode.Tree) },
                icon = Icons.Default.AccountTree,
                description = "Tree view"
            )
            Spacer(Modifier.height(4.dp))
        }*/

        TooltipIconButton(
            tooltip = formatDescription,
            onClick = { if (isMinified) onFormat() else onMinify() }
        ) {
            Icon(
                imageVector = formatIcon,
                contentDescription = formatDescription
            )
        }

        TooltipIconButton(
            tooltip = "Search",
            onClick = { onSearch() }
        ) {
            Icon(
                imageVector = Icons.Default.Search,
                contentDescription = "Search"
            )
        }

        TooltipIconButton(
            tooltip = "Copy",
            onClick = {
                clipboard.setText(AnnotatedString(text))
                onCopy()
            }
        ) {
            Icon(
                imageVector = Icons.Default.ContentCopy,
                contentDescription = "Copy"
            )
        }

        TooltipIconButton(
            tooltip = "Download",
            onClick = { FileExport.default.downloadJson("jsonize.json", text) }
        ) {
            Icon(
                imageVector = Icons.Default.Download,
                contentDescription = "Download"
            )
        }
    }
}

fun isLikelyMinifiedJson(text: String): Boolean {
    if (text.isBlank()) return false
    val trimmed = text.trim()
    if (!trimmed.contains('\n') && !trimmed.contains('\r')) return true
    return false
}

@Composable
fun ViewModeButton(
    selected: Boolean,
    onClick: () -> Unit,
    icon: ImageVector,
    description: String
) {
    val colors = if (selected) {
        IconButtonDefaults.iconButtonColors(
            containerColor = MaterialTheme.colorScheme.secondaryContainer,
            contentColor = MaterialTheme.colorScheme.onSecondaryContainer
        )
    } else {
        IconButtonDefaults.iconButtonColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f),
            contentColor = MaterialTheme.colorScheme.onSurfaceVariant
        )
    }

    TooltipIconButton(
        tooltip = description,
        onClick = onClick,
        colors = colors,
        modifier = Modifier.size(40.dp)
    ) {
        Icon(icon, contentDescription = description)
    }
}

@Composable
fun FeatureToolbar(
    text: String,
    isFormatting: Boolean,
    treeView: () -> Unit,
    compareView: () -> Unit,
    generatorView: () -> Unit,
    viewMode: EditorViewMode,
    onViewModeChange: (EditorViewMode) -> Unit,
    showViewToggle: Boolean,
    extras: @Composable ColumnScope.() -> Unit
) {

    Column(verticalArrangement = Arrangement.spacedBy(6.dp),
        horizontalAlignment = Alignment.CenterHorizontally) {
        if (showViewToggle) {
            ViewModeButton(
                selected = viewMode == EditorViewMode.Code,
                onClick = { onViewModeChange(EditorViewMode.Code) },
                icon = Icons.Default.Code,
                description = "Code view"
            )
            ViewModeButton(
                selected = viewMode == EditorViewMode.Tree,
                onClick = { onViewModeChange(EditorViewMode.Tree) },
                icon = Icons.Default.AccountTree,
                description = "Tree view"
            )
            ViewModeButton(
                selected = viewMode == EditorViewMode.Generator,
                onClick = { onViewModeChange(EditorViewMode.Generator) },
                icon = Icons.Default.Code,
                description = "Tree view"
            )
            Spacer(Modifier.height(4.dp))
        }

        TooltipIconButton(
            tooltip = "Tree view",
            onClick = { treeView() }
        ) {
            Icon(
                imageVector = Icons.Default.AccountTree,
                contentDescription = "Tree view"
            )
        }

        TooltipIconButton(
            tooltip = "Compare",
            onClick = { compareView() }
        ) {
            Icon(
                imageVector = Icons.Default.Compare,
                contentDescription = "Compare"
            )
        }

        TooltipIconButton(
            tooltip = "Code Generator",
            onClick = { generatorView() }
        ) {
            Icon(
                imageVector = Icons.Default.Code,
                contentDescription = "Code Generator"
            )
        }

        HorizontalDivider(Modifier.width(40.dp))

        extras()
    }
}
